import * as React from 'react';

export const Loader = ({showLoader = 'hide'}) => {
    return (
        <>
            <div id="loader" className={showLoader} role="status" aria-live="polite"
                 aria-busy={showLoader === 'show'}>
            </div>
        </>
    );
}
